var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99988 8C1.99988 5.17157 1.99988 3.75736 2.87856 2.87868C3.75724 2 5.17145 2 7.99988 2C10.8283 2 12.2425 2 13.1212 2.87868C13.9999 3.75736 13.9999 5.17157 13.9999 8C13.9999 10.8284 13.9999 12.2426 13.1212 13.1213C12.2425 14 10.8283 14 7.99988 14C5.17145 14 3.75724 14 2.87856 13.1213C1.99988 12.2426 1.99988 10.8284 1.99988 8Z",
    stroke: "currentColor",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69995 8.5L7.03328 9.83333L10.3666 6.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.72a9614c203a178a624d7f969621d0e2.svg";
export { ForwardRef as ReactComponent };